import Component from './widget_preview_message.vue'
export default Component
